import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const BackButton = ({ label = 'Back', style = {}, onClick, platform }) => {
  const history = useHistory();
  const isMobile = platform === 'mobile';

  const handleClick = () => {
    if (onClick) onClick();
    else history.goBack();
  };

  return (
    <Button
      icon={<ArrowLeftOutlined />}
      onClick={handleClick}
      size={isMobile ? 'small' : 'middle'}
      style={{
        position: 'static',
        borderRadius: 6,
        fontWeight: 500,
        fontSize: isMobile ? '12px' : '14px',
        ...style,
      }}
    >
      {!isMobile ? label : null}
    </Button>
  );
};


export default BackButton;